import styled from 'styled-components'

const StyledSubTitle = styled.sub`
font-size: 1.1em;
text-transform: capitalize`

export const SubTitle = props => {
    return <StyledSubTitle>{props.children}</StyledSubTitle>
}